//================================================================
//  Component: User Search
//================================================================

//  Purpose: This is an input field that allows you to search all LL Users and select a project

//  Properties:
//    - selectedProject = {useReducer, this stores the current selected project, search results and query message}
//    - setSelectedProject = {useReducer, this is used to set the selected project state}
//    - errorMessage = {string, error message}

// <REQUIRED> useReducer structure:
//      {
//          'footprintid': '', // email of the selected project
//          'footprintname': '', // fullname of the selected project
//          'searchResults': [],
//          'queryMessage': '',
//      }

//  Example:
//    <FootprintProjectSearch
//      selectedProject={formData}
//      setSelectedProject={setFormData}
//      errorMessage={errorMessage}
//    ></FootprintProjectSearch>    

//================================================================


//Libraries
import React from 'react';

//Contexts

//Components

//Functions
import QueryDocument from '../../Library/QueryDocument';

//Images


export default function FootprintProjectSearch({
    selectedProject,
    setSelectedProject,
    errorMessage,
}) {

    //------------------------------------------------------
    //  Functions
    //------------------------------------------------------

    // Function used to handle search
    function handleSearch(value) {

        setSelectedProject({ 
            'queryMessage': '',
            'footprintname': value, // Footprint project name
        });

        if (value?.length <= 2) {

            setSelectedProject({ 
                'queryMessage': 'Search requires more than two characters.',
                'searchResults': [],
                'footprintid': '', // Footprint project id
            });
            return;

        }

        const query = value?.toLowerCase();

        // Search by characters in email
        QueryDocument('footprintprojects', [
            ['searcharray', 'array-contains-any', [query]],
            ['status', '==', 'active'],
        ])
        .then((projects) => {

            console.log('HERE!!!!! PROJECTS', selectedProject)

            setSelectedProject({
                'footprintid': '', // Footprint project id
                'searchResults': projects,
                'queryMessage': `Showing ${projects?.length} result(s)`,
            });

        })
        .catch((error) => {

            console.log(error);
            setSelectedProject({ 'queryMessage': 'Oops something went wrong!' });

        });

    }

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='flex flex-col w-[530px] h-full relative'>

            {/* ------------------------------------------------------ */}
            {/*  Project Search Bar                                    */}
            {/* ------------------------------------------------------ */}

            {/* Search Bar */}
            <div className='flex flex-row items-center'>

                {/* Search Input Field */}
                <input
                    className={
                        errorMessage?.length > 0 ?
                            'w-full h-[42px] px-[15px] py-[10px] bg-[white] shadow-md border-1 border-solid border-[#DE0000] rounded-[5px]'
                            :
                            selectedProject?.searchResults?.length > 0 ?
                                'w-full h-[42px] px-[15px] py-[10px] bg-[white] shadow-md border border-solid border-[#7c7c7c] rounded-tl-[5px] rounded-br-none rounded-tr-[5px] rounded-bl-none'
                                :
                                'w-full h-[42px] px-[15px] py-[10px] bg-[white] shadow-md border border-solid border-[#7c7c7c] rounded-[5px]'
                    }
                    value={selectedProject?.footprintname}
                    type='text'
                    placeholder='Level 14, Barangaroo'
                    onChange={(e) => handleSearch(e.target.value)}
                    autoComplete='off'
                ></input>

            </div>

            {/* Error Message */}
            <p className='font-medium text-sm text-[var(--darkred)] my-2' hidden={errorMessage === ''} >
                {errorMessage}
            </p>

            {/* Search Results */}
            <div className='absolute w-full top-11 max-h-[150px] overflow-y-auto bg-white shadow-md rounded-tl-none rounded-br-[5px] rounded-tr-none rounded-bl-[5px]'>

                {/* No Results */}
                {
                    (selectedProject?.searchResults?.length === 0 && selectedProject?.footprintid === '' && selectedProject?.footprintname !== '') &&

                        <div className='font-medium text-[14px] px-3 py-[12px]'>
                            No results found.
                        </div>
                }

                {/* Results */}
                {
                    selectedProject?.searchResults?.length > 0 &&

                        selectedProject?.searchResults.map((project, index) => (
                            <div
                                key={index}
                                className='flex flex-row justify-between px-4 py-[13px] cursor-pointer rounded-sm hover:bg-[#F0F0F0]'
                                onClick={() => {

                                    setSelectedProject({
                                        'searchResults': [],
                                        'footprintid': project?.footprintid,
                                        'footprintname': project?.footprintname,
                                        'queryMessage': '',
                                    });

                                }}
                            >

                                {/* Project Detail */}
                                <div className='flex flex-col'>
                                    <p className='m-0 font-medium text-[14px]'>{project?.footprintname}</p>
                                    <p className='m-0 text-[14px]'>{project?.footprintid}</p>
                                </div>

                            </div>
                        ))
                }

                {/* Total */}
                <div className='text-sm font-medium px-4 py-2 border-t border-t-[#D8D8D8]' hidden={selectedProject.queryMessage.length === 0}>
                    {selectedProject.queryMessage}
                </div>

            </div>

        </div>
    )

    //------------------------------------------------------

}
